import React, { useContext, useEffect, useState } from 'react';
import PokemonImg from './pokemonImg/pokemonImg';
import BtnOffcanvas from './btn/btnOffcanvas';
import BtnRounded from './btn/btnRounded';
import BestTeams from './bestTeams';
import AddItemBtn from './btn/addItemBtn';
import uuid from 'uuidv4';
import { PokedexContext } from '../Data/Context/pokemonData';
import { BuildContext } from '../Data/Context/buildData';
import { useParams } from 'react-router-dom';
import { DatabaseContext } from '../Controllers/Database';
import Axios from 'axios';
import { AppConfigContext, axios_timeout } from '../Config/App';
import { getUserFromLocalStorage } from '../utils/localStorage';
import { LanguageContext } from '../Data/Context/languageContext';
import SelectDark from './select/selectDark';
import options from '../Data/gameVersions.json';
import { toast } from 'react-toastify';
import Notes from './notes/notes';
import { motion } from "framer-motion";

const PokemonInfo = () => {
    let teammates = [];
    const { pokemonData } = useContext(PokedexContext);
    const { clearBuild, updateGeneralNotes, buildDataFromDB, buildMode, clearTeammates, updateGameVersion } = useContext(BuildContext);
    const { castVote } = useContext(DatabaseContext);
    const { api_url, assets_url } = useContext(AppConfigContext);
    const [generalNotes, setGeneralNotes] = useState('');
    const [generalNotesDB, setGeneralNotesDB] = useState(buildDataFromDB ? buildDataFromDB.notes.general_notes : '');
    const { viewingID, editingID } = useParams();
    const user_session = getUserFromLocalStorage();

    const [likes, setLikes] = useState(0);
    const [dislikes, setDislikes] = useState(0);
    const [likeBtnClasses, setLikeBtnClasses] = useState("");

    const [likeBtnActive, setBtnLikeActive] = useState();
    const [dislikeBtnActive, setBtnDislikeActive] = useState();
    const [dislikeBtnClasses, setDislikeBtnClasses] = useState("");

    const [isLoaded, setIsLoaded] = useState(false);

    const { t } = useContext(LanguageContext);
    const customId = "custom-id-yes";

    const notify = () => {
        toast.warn(t("toast_must_be_logged_in"), {
            toastId: customId,
            autoClose: false
        });
    }

    function like_btn() {
        setTimeout(() => {
            if (likeBtnActive) {
                setLikes(likes + 1);
                setBtnLikeActive(false);
                setLikeBtnClasses("fa-thumbs-up-deactivated");
                castVote(true, buildDataFromDB.build_id, false);
            } else {
                if (likes > 0) {
                    setLikes(likes - 1);
                }
                setBtnLikeActive(true);
                setLikeBtnClasses("");
                castVote(true, buildDataFromDB.build_id, true);
            }
        }, 100);
    }

    function dislike_btn() {
        setTimeout(() => {
            if (dislikeBtnActive) {
                setDislikes(dislikes + 1);
                setBtnDislikeActive(false);
                setDislikeBtnClasses("fa-thumbs-down-deactivated");
                castVote(false, buildDataFromDB.build_id, false);
            } else {
                if (dislikes > 0) {
                    setDislikes(dislikes - 1);
                }
                setBtnDislikeActive(true);
                setDislikeBtnClasses("");
                castVote(false, buildDataFromDB.build_id, true);
            }
        }, 100);
    }

    const can_vote_like = () => {
        Axios.post(api_url(`can-vote-like`), {
            user_id: user_session.user_id,
            build_id: viewingID,
            token: user_session.token
        }, { timeout: axios_timeout }
        ).then(response => {
            if (response.status === 200) {
                setBtnLikeActive(true);
                setLikeBtnClasses("");
            } else {
                setBtnLikeActive(false);
                setLikeBtnClasses("fa-thumbs-up-deactivated");
            }
        }).catch(err => {
            console.log(err.code, err.stack, err.message);
        });
    }

    const can_vote_dislike = () => {
        Axios.post(api_url(`can-vote-dislike`), {
            user_id: user_session.user_id,
            build_id: viewingID,
            token: user_session.token
        }, { timeout: axios_timeout }
        ).then(response => {
            if (response.status === 200) {
                setBtnDislikeActive(true);
                setDislikeBtnClasses("");
            } else {
                setBtnDislikeActive(false);
                setDislikeBtnClasses("fa-thumbs-down-deactivated");
            }
        }).catch(err => {
            console.log(err.code, err.stack, err.message);
        });
    }

    const build_ratio = () => {
        Axios.get(api_url("build-ratio/" + viewingID), { timeout: axios_timeout })
            .then(response => {
                if (response.status === 200) {
                    if(user_session) {
                        can_vote_like();
                        can_vote_dislike();
                    }
                }
            })
            .catch(err => {
                console.log(err.code, err.stack, err.message);
            });
    }

    const intial_ratio = () => {
        Axios.get(api_url("build-ratio/" + viewingID), { timeout: axios_timeout })
            .then(response => {
                if (response.status === 200) {
                    setLikes(response.data.likes);
                    setDislikes(response.data.dislikes);
                }
            })
            .catch(err => {
                console.log(err.code, err.stack, err.message);
            });
    }

    useEffect(() => {
        if (viewingID) intial_ratio();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (viewingID) {
            build_ratio();
        }
        // eslint-disable-next-line
    }, [likes, dislikes]);

    useEffect(() => {
        if (buildMode === 'building') {
            clearBuild(true);
        }
        // eslint-disable-next-line
    }, [buildMode]);

    useEffect(() => {
        if (editingID) {
            updateGeneralNotes(generalNotesDB);
        } else {
            updateGeneralNotes(generalNotes);
        }
        // eslint-disable-next-line
    }, [generalNotes, generalNotesDB]);

    useEffect(() => {
        if (!user_session) {
            setBtnLikeActive(false);
            setLikeBtnClasses("fa-thumbs-up-deactivated");
            setBtnDislikeActive(false);
            setDislikeBtnClasses("fa-thumbs-down-deactivated");
        }

        setTimeout(() => {
            setIsLoaded(true);
        }, 200);
        // eslint-disable-next-line
    }, []);

    teammates.push(<div key={uuid()} className='row mt-3 best-teams options'><p className='text-center'>{t("team")} 1</p></div>)

    if (buildMode === 'building' || buildMode === 'editing') {
        for (let i = 1; i <= 6; i++) {
            if (i === 4) teammates.push(<div key={uuid()} className='row mt-3 best-teams options'><p className='text-center'>{t("team")} 2</p></div>)
            teammates.push(
                <AddItemBtn key={uuid()} index={i} itemType={'pokemon'} modal={'#teammates-modal'} classes={'mx-1'}></AddItemBtn>
            );
        }
    }

    if (buildMode === 'viewing' && buildDataFromDB) {
        for (let i = 1; i <= 6; i++) {
            if (i === 3 && buildDataFromDB.teammates.teammate_3 !== '') teammates.push(<div key={uuid()} className='row mt-3 best-teams options'><p className='text-center'>{t("team")} 2</p></div>)
            if (buildDataFromDB.teammates['teammate_' + i]) {
                teammates.push(<AddItemBtn key={uuid()} index={i} itemType={'pokemon'} classes={'mx-1'}></AddItemBtn>)
            }
        }
    }

    return (
        <div className={`col-lg-5 col-xl-4 col-xxl-3 mb-4 mb-lg-0 pb-3 purple-bk rounded shadow-bg-sm`}>
            <div className="row">
                <div className="col py-0 pb-lg-3 text-center mt-3 mt-lg-0">
                    <div className="d-flex flex-row flex-lg-column justify-content-center align-items-center">

                        {isLoaded &&
                            <>
                                <div className='d-none d-lg-block'>
                                    <PokemonImg classes="img-fluid" borderType="blue-border" src={assets_url("pokedex/" + pokemonData.sprites.pokeland)} alt={"Pokeland Legends " + pokemonData.name.pokeland} animated={true} />
                                </div>
                                <div className='d-block d-lg-none col-3 col-sm-2'>
                                    <PokemonImg classes="img-fluid" borderType="blue-border" src={assets_url("pokedex/thumbnails/" + pokemonData.sprites.pokeland)} alt={"Pokeland Legends " + pokemonData.name.pokeland} animated={true} />
                                </div>
                            </>
                        }

                        {buildMode === 'building' && <BtnOffcanvas classes="btn-primary mt-0 mt-lg-3 ms-3 ms-lg-0" offcanvas="offcanvas-search-1" text={t("change_pokemon")} />}

                        {buildMode === 'editing' && <p className='yellow my-3 ms-3 ms-lg-0'>{t("edit_mode")}</p>}

                        {buildMode === 'viewing' &&
                            <div className='d-flex flex-column justify-content-center build-vote mt-0 mt-lg-3 ms-3 ms-lg-0'>
                                <p className='yellow my-3'>{t("created_by")}: {buildDataFromDB.username}</p>
                                <p className='yellow'>{t("vote_on")}</p>

                                <div className='d-flex justify-content-around'>
                                    <div className='col'>
                                        <motion.button whileTap={{ scale: 0.5 }} className={`btn fa-solid fa-thumbs-up cast-vote ${likeBtnClasses}`} onClick={() => user_session ? like_btn() : notify()}></motion.button>
                                        <p>{likes}</p>
                                    </div>
                                    <div className='col mt-1'>
                                        <motion.button whileTap={{ scale: 0.5 }} className={`btn mb-1 fa-solid fa-thumbs-down cast-vote ${dislikeBtnClasses}`} onClick={() => user_session ? dislike_btn() : notify()}></motion.button>
                                        <p>{dislikes}</p>
                                    </div>
                                </div>

                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="d-flex justify-content-center">
                        <a href={`https://pokeland-legends.club/database/pokemon/${pokemonData.variation}/${pokemonData.name.pokeland.replaceAll(" ", "-")}`} target="_blank" rel="noreferrer">
                            <BtnRounded classes="mx-2 mt-3 mt-lg-0">{t("pokedex_info")}</BtnRounded>
                        </a>
                    </div>
                </div>
            </div>

            {(buildMode === 'viewing' && buildDataFromDB && buildDataFromDB.teammates.teammate_1 !== '') &&
                <>
                    <BestTeams id="best-teams" title={t("teammates_for")} pokemonName={pokemonData.name.pokeland}>
                        {teammates}
                    </BestTeams>
                </>
            }

            {(buildMode === 'building' || buildMode === 'editing') &&
                <>
                    <BestTeams id="best-teams" title={t("teammates_for")} pokemonName={pokemonData.name.pokeland}>
                        {teammates}
                    </BestTeams>
                </>
            }

            {(buildMode === 'building' || buildMode === 'editing') &&
                <div className='text-center mt-4 pb-2'>
                    <BtnRounded callFunction={clearTeammates} classes="mx-2 mb-3">{t("clear")}</BtnRounded>
                </div>
            }

            {!viewingID && !editingID && isLoaded &&
                <>
                    <p className='yellow mb-3 text-center'>{t("general_notes")}</p>
                    <Notes classes={'pt-3'} setNotes={setGeneralNotes}></Notes>
                </>
            }

            {editingID && isLoaded &&
                <Notes classes={'pt-3'} setNotes={setGeneralNotesDB} notes={buildDataFromDB && buildDataFromDB.notes.general_notes ? buildDataFromDB.notes.general_notes : ''}></Notes>
            }

            {viewingID && buildDataFromDB && buildDataFromDB.notes.general_notes &&
                <Notes classes={'pt-3'} notes={buildDataFromDB.notes.general_notes}></Notes>
            }

            {buildMode === 'building' &&
                <>
                    <p className='yellow mt-4 mb-3 text-center'>{t("game_version")}</p>
                    <SelectDark classes={"mt-4"} options={options} callBack={updateGameVersion} />
                </>
            }

            {editingID && buildDataFromDB &&
                <SelectDark classes={"mt-4"} options={options} callBack={updateGameVersion} selectedValue={buildDataFromDB.gameVersion} />
            }
        </div>
    );
}
export default PokemonInfo;